import { getMonthNumeric } from './month';
/**
 * Returns a numerical representation of the quarter: 1, 2, 3, 4
 * @hidden
 */
export const getQuarterNumeric = (params) => {
    const month = getMonthNumeric(params);
    return Math.ceil(month / 3);
};
/**
 * Returns an ordinal string representation of the quarter: 1st, 2nd, 3rd, 4th
 * @hidden
 */
export const getQuarterOrdinal = (params) => {
    const quarter = getQuarterNumeric(params);
    return params.ordinalStringFormatter(quarter);
};
//# sourceMappingURL=quarter.js.map